import { useExperiments } from '../contexts/ExperimentsContext';

export const useIsStudio2Ui = () =>
  useExperiments().is('studioTemplatesOnlyStudio2', 'true');
